import Component from '@glimmer/component';
import { beebeeAjaxPost } from 'beebee-base/lib/utility';
import { notifyUserError } from 'beebee-base/lib/utility';
import { action } from '@ember/object';

import { task } from 'ember-concurrency';

import { tracked } from '@glimmer/tracking';

import { inject as iService } from '@ember/service';

import getConfig from 'beebee-base/lib/get-config';
/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component (contact popup form + "send admin mail" task)
 *   extends:   Component (@glimmer/component)
 *   template:  contact-button.hbs
 *   args:      -
 *   uses:      beebeeAjaxPost, notifyUserError (beebee-base/lib/utility),
 *              getConfig (beebee-base/lib/get-config), ember-concurrency task
 *   siblings:  -
 *   tests:     contact-button-test.js, list-components-test.js, wave7-coverage-test.js, ui-components-test.js
 *
 * Toggleable contact popup: validates name/email/mobile locally, then posts to
 * `/send_admin_mail` via a `.drop()` task. Class is named `ExampleComponent`
 * verbatim in source despite the exported filename.
 */
export default class ExampleComponent extends Component {
  @iService intl;
  @iService session;
  @iService notify;
  @iService log;

  @tracked isShown = false;
  @tracked isSuccess = false;
  @tracked bookError = null;
  @tracked requiredEmpty = {};
  @tracked termAccepted = false;
  @tracked contact_name = '';
  @tracked contact_mail = '';
  @tracked contact_mobile = '';
  @tracked contact_message = '';

  @action
  openPopup() {
    this.isShown = !this.isShown;
    this.isSuccess = false;
  }

  @(task(function* () {
    let emptyRequiredField = false;
    this.bookError = null;
    const empty = {};

    if (!this.contact_name) {
      empty.contact_name = true;
      emptyRequiredField = true;
    }

    var validateEmail = function (email) {
      var re = /\S+@\S+\.\S+/;
      return re.test(email);
    };

    if (!this.contact_mail || !validateEmail(this.contact_mail)) {
      empty.contact_mail = true;
      emptyRequiredField = true;
    }

    if (!this.contact_mobile) {
      empty.contact_mobile = true;
      emptyRequiredField = true;
    }

    this.requiredEmpty = empty;

    if (emptyRequiredField) {
      this.bookError = {
        errors: [
          {
            detail: this.intl.t('empty required field'),
          },
        ],
      };
      return;
    }

    try {
      yield beebeeAjaxPost(`${getConfig(this).APP.urlApi}/send_admin_mail`, null, {
        contact_name: this.contact_name,
        contact_mail: this.contact_mail,
        contact_mobile: this.contact_mobile,
        product_name: null,
        from_date: null,
        to_date: null,
        contact_message: this.contact_message,
        thumbnail_url: this.session.openOrganization?.thumbnail_url,
        color: this.session.openOrganization?.primary_color,
        lang: this.intl.primaryLocale,
      });
    } catch (e) {
      this.log.error('sendContactMailTask failed', e);
      notifyUserError(this.notify, e, this.intl);
      return;
    }

    this.isSuccess = true;
  }).drop())
  sendContactMailTask;
}
